import styled from "styled-components"
import Wrapper from "./Wrapper"

const WrapperNoNumber = styled(Wrapper)`
  padding: ${({theme}) => theme.spacing.one};
`

export default WrapperNoNumber
